import React, { useState, useEffect } from 'react';
import { Table, Button, message, Space, Modal } from 'antd';
import axios from 'axios';
import { apiUrl } from './config';
import { Preferences } from '@capacitor/preferences';

const RegistrationRequestsPage = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [approveModalVisible, setApproveModalVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [existingUserModalVisible, setExistingUserModalVisible] = useState(false);
    const [existingUserMessage, setExistingUserMessage] = useState('');
    const [currentRequestId, setCurrentRequestId] = useState(null);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/auth/register-requests`);
            setRequests(response.data);
        } catch (error) {
            message.error('Errore durante il recupero delle richieste.');
        } finally {
            setLoading(false);
        }
    };

    // resetExisting = true quando il trainer conferma di voler rigenerare la
    // password di un account che esiste già.
    const approveRequest = async (resetExisting = false) => {
        try {
            // Il trainer che approva lo ricava il server dal token.
            const response = await axios.post(`${apiUrl}/api/auth/approve-request`, {
                requestId: currentRequestId,
                resetExisting,
            });
            message.success(response.data?.message || 'Richiesta approvata, password temporanea inviata!');
            fetchRequests();
            setApproveModalVisible(false);
            setExistingUserModalVisible(false);
        } catch (error) {
            const data = error.response?.data;

            // L'utente ha già un account: chiedi al trainer se inviargli una nuova password.
            if (data?.code === 'USER_EXISTS') {
                setApproveModalVisible(false);
                setExistingUserMessage(data.message);
                setExistingUserModalVisible(true);
                return;
            }

            message.error(data?.message || "Errore durante l'approvazione della richiesta.");
        }
    };

    const handleApprove = () => approveRequest(false);

    const handleDelete = async () => {
        try {
            const token = (await Preferences.get({ key: 'token' })).value;
            await axios.delete(`${apiUrl}/api/auth/register-requests/${currentRequestId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            message.success('Richiesta cancellata con successo!');
            fetchRequests();
            setDeleteModalVisible(false);
        } catch (error) {
            message.error('Errore durante la cancellazione della richiesta.');
        }
    };

    const showApproveModal = (requestId) => {
        setCurrentRequestId(requestId);
        setApproveModalVisible(true);
    };

    const showDeleteModal = (requestId) => {
        setCurrentRequestId(requestId);
        setDeleteModalVisible(true);
    };

    const columns = [
        {
            title: 'Dettagli Richiesta',
            key: 'details',
            render: (text, record) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <div>
                        <p><strong>Nome:</strong> {record.nome}</p>
                        <p><strong>Cognome:</strong> {record.cognome}</p>
                        <p><strong>Email:</strong> {record.email}</p>
                        <p><strong>Note:</strong> {record.note || 'Nessuna nota'}</p>
                    </div>
                    <div style={{ marginTop: '10px', textAlign: 'right' }}>
                        <Space size="middle">
                            <Button type="primary" onClick={() => showApproveModal(record._id)}>
                                Approva e Invia Password
                            </Button>
                            <Button type="danger" onClick={() => showDeleteModal(record._id)}>
                                Elimina
                            </Button>
                        </Space>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div>
            <h2>Richieste di Registrazione</h2>
            <Table
                dataSource={requests}
                columns={columns}
                loading={loading}
                rowKey="_id"
                pagination={false}
                style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
            />

            <Modal
                title="Conferma Approva Richiesta"
                open={approveModalVisible}
                getContainer={document.body}
                onOk={handleApprove}
                onCancel={() => setApproveModalVisible(false)}
                okText="Sì"
                cancelText="No"
                className="custom-modal"
            >
                Sei sicuro di voler approvare questa richiesta e inviare la password temporanea?
            </Modal>

            <Modal
                title="Conferma Eliminazione Richiesta"
                open={deleteModalVisible}
                getContainer={document.body}
                onOk={handleDelete}
                onCancel={() => setDeleteModalVisible(false)}
                okText="Sì"
                cancelText="No"
                className="custom-modal"
            >
                Sei sicuro di voler cancellare questa richiesta?
            </Modal>

            <Modal
                title="Utente già registrato"
                open={existingUserModalVisible}
                getContainer={document.body}
                onOk={() => approveRequest(true)}
                onCancel={() => setExistingUserModalVisible(false)}
                okText="Invia nuova password"
                cancelText="Annulla"
                className="custom-modal"
            >
                <p>{existingUserMessage}</p>
                <p>Vuoi inviargli una nuova password temporanea e chiudere questa richiesta?</p>
            </Modal>
        </div>
    );
};

export default RegistrationRequestsPage;
